import { Routes } from '@angular/router';

import { environment } from '../environments/environment';

/**
 * Sólo el armazón: las pantallas reales viven en `libs/app/feature-*` y llegan con TEC-483. Viajes,
 * Boletos y Perfil son la barra inferior de Home, la que manda en el diseño.
 */
export const routes: Routes = [
  { path: '', redirectTo: 'tabs/viajes', pathMatch: 'full' },
  {
    path: 'tabs',
    loadComponent: () => import('./tabs/tabs.page').then((m) => m.TabsPage),
    children: [
      { path: '', redirectTo: 'viajes', pathMatch: 'full' },
      {
        path: 'viajes',
        data: { title: 'Viajes' },
        loadComponent: () => import('./placeholder/placeholder.page').then((m) => m.PlaceholderPage),
      },
      {
        path: 'boletos',
        data: { title: 'Boletos' },
        loadComponent: () => import('./placeholder/placeholder.page').then((m) => m.PlaceholderPage),
      },
      {
        path: 'perfil',
        data: { title: 'Perfil' },
        loadComponent: () => import('./placeholder/placeholder.page').then((m) => m.PlaceholderPage),
      },
    ],
  },
  {
    path: 'galeria',
    canMatch: [() => environment.gallery],
    loadComponent: () => import('@movilidad/app-feature-gallery').then((m) => m.GalleryPage),
  },
  { path: '**', redirectTo: '' },
];
